import { AbstractControl, ValidatorFn } from '@angular/forms';

export function startCharacterValidator(): ValidatorFn {
    return (control: AbstractControl): {[key: string]: any} | null => {
        const re = /^[+|\-|=|@]/;
        const v = String(control.value);

        return (v !== "null" && v.length > 0
            && re.test(v)) ? {'InvalidStartCharacter': {value: v}} : null; 
    };
}